import { useInstallPrompt } from './useInstallPrompt';
import './pwa.css';

/**
 * "Instalar app" (brief requisito 4): mismo componente para el Inicio del
 * alumno (`variant="card"`, sobre superficie clara) y el sidebar/drawer
 * (`variant="compact"`, sobre la superficie oscura). Renderiza nada si ya
 * está instalada, o si ni el evento de Android ni un iPhone aplican.
 */
export function InstallPrompt({ variant = 'card' }) {
  const { canInstall, showIosCard, promptInstall, dismiss } = useInstallPrompt();

  if (!canInstall && !showIosCard) return null;

  const rootClassName = variant === 'compact'
    ? 'gym-pwa-install gym-pwa-install--compact'
    : 'gym-card gym-pwa-install gym-pwa-install--card';

  if (canInstall) {
    return (
      <div className={rootClassName}>
        <p className="gym-pwa-install__text">Instalá HAMMER en tu teléfono para entrar más rápido.</p>
        <div className="gym-pwa-install__actions">
          <button type="button" className="gym-button gym-button--primary" onClick={promptInstall}>
            Instalar app
          </button>
          <button type="button" className="gym-pwa-install__dismiss" onClick={dismiss}>
            Ahora no
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={rootClassName}>
      <p className="gym-pwa-install__text">
        Para instalar HAMMER: tocá <strong>Compartir</strong> y elegí{' '}
        <strong>Agregar a pantalla de inicio</strong>.
      </p>
    </div>
  );
}
